<template>
    <div>
        <v-data-table :loader="isSearching" @sort="$emit('sort', $event)" :sort="sort" :headers="headers" :records="records">
            <template slot="head-region" scope="props">
                <v-dropdown :items="regions" @select="$emit('filter', $event)">
                    <div>
                        <v-font-icon small>filter_list</v-font-icon>
                        <span v-margin.left="1">Регион</span>
                    </div>
                </v-dropdown>
            </template>
            <template slot="cell-action" scope="props">
                <v-radio :value="value" @input="$emit('input', props.item)" :data="props.item" />
            </template>
        </v-data-table>
        <div v-padding="3">
            <v-row align-items="center">
                <v-col>
                    <v-pagination @click="$emit('paginate', $event)" :total="total" :display="display" :current="page" />
                </v-col>
                <v-col v-text-align.right>
                    <slot></slot>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    const companyHeaders = {
        action: {
            sort: false,
            label: '',
        },
        region: {
            sort: false,
            label: 'Регион',
        },
        address: { label: 'Адрес' },
        inn: { label: 'ИНН' },
        name: { label: 'Название' },
    };

    const individualHeaders = {
        action: {
            sort: false,
            label: '',
        },
        region: {
            sort: false,
            label: 'Регион',
        },
        ogrn: { label: 'ОГРНИП' },
        inn: { label: 'ИНН' },
        name: { label: 'ФИО' },
    };

    export default {
        name: 'request-table-inns',
        props: {
            value: Object,
            regions: {
                type: Array,
                default() {
                    return [];
                }
            },
            page: {
                type: Number,
                default: 1,
            },
            total: {
                type: Number,
                default: 100,
            },
            display: {
                type: Number,
                default: 4,
            },
            records: {
                type: Array,
                default() {
                    return [];
                }
            },
            sort: {
                type: Object,
                default() {
                    return {
                        column: 'name',
                        order: 'desc',
                    };
                }
            },
            isIndividual: Boolean,
            isSearching: Boolean,
        },
        computed: {
            headers() {
                return this.isIndividual ? individualHeaders : companyHeaders;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// RequestTableInns.vue?164ae226